import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-installments',
  templateUrl: './installments.component.html',
  styleUrls: ['./installments.component.css']
})
export class InstallmentsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
